<template>
  <div class="cockpit-card" :class="`${cardType}-card`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CockpitCard',
  props: {
    // default | horizontal | fullscreen
    cardType: {
      type: String,
      defalut: 'default',
    },
  },
}
</script>

<style lang="scss" scoped>
.cockpit-card {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: var(--containerPadding);
  &.default-card {
    background-image: var(--containerBgImg);
  }
  &.horizontal-card {
    background-image: var(--horizontalBgImg);
  }
  &.fullscreen-card {
    background-image: var(--fullscreenBgImg);
  }
}
</style>
